import axios from "axios";
import utils from "@/services/utils";

export default {
  async search(searchOptions) {
    try {
      const response = await axios.get("/sighting/images", {
        params: {
          ...utils.buildApiSearchQuery(searchOptions, "imageNumber", false),
          start_date: searchOptions.startDate,
          end_date: searchOptions.endDate,
          species: searchOptions.species.join(";"),
          unassociated_only: searchOptions.unassociatedOnly || undefined,
          associated_only: searchOptions.associatedOnly || undefined,
        },
      });
      const data = response.data;
      return { message: "Loaded images", data: data.items, total: data.total };
    } catch (e) {
      return { message: "No images found", data: [], total: 0 };
    }
  },
  uploadImages(photos) {
    let formData = new FormData();
    photos.forEach(photo => formData.append("image_files", photo.file));
    photos.forEach(photo => formData.append("names", photo.name));
    photos.forEach(photo => formData.append("image_numbers", photo.imageNumber));
    photos.forEach(photo => formData.append("whale_ids", photo.whaleId));
    photos.forEach(photo => formData.append("sighting_numbers", photo.sightingNumber));
    return axios.put(`/upload/image_upload`, formData);
  },
};
